import { AgTechPopUpCoreProps } from "@agtech/core/functions/AgTechAppPopUps"
import { AgTechClickEventHandler, AgTechLink } from "../Buttons/AgTechButtons"
import { AgTechClassNames, combineClassNames } from "@agtech/core/components/AgTechProps"
import AgTechIconBadge from "../Icons/AgTechIconBadge"

export type AgTechHeaderDetailProps = {
    header: string,
    detail?: string,
    settings?: {
        header?: {
            classes?: AgTechClassNames,
            onClick?: (e: AgTechClickEventHandler) => void,
            onHover?: () => AgTechPopUpCoreProps
        },
        detail?: {
            classes?: AgTechClassNames
        },
        badge?: {
            icon: string,
            classes?: AgTechClassNames,
            badgeSize?: number
        },
        content?: {
            body?: () => React.ReactNode,
            classes?: string
        }
        classes?: string,
        showMarker?: boolean
    }
}

const AgTechHeaderDetail = (props: AgTechHeaderDetailProps & { children?: JSX.Element }) => {
    const contentFunc = props.children ? () => props.children : props.settings?.content?.body;

    return (
        <div className={`column-based wide flex ${props.settings?.classes ?? ''}`}>
            {props.settings?.showMarker && (
                <div className='tall w-[3px] my-1 bg-slate-300 rounded mr-3 flex' />
            )}

            {props.settings?.badge && (
                <>
                    {props.settings?.badge.badgeSize ? (
                        <AgTechIconBadge
                            icon={props.settings.badge.icon}
                            badgeClasses={combineClassNames(props.settings.badge.classes)}
                            size={props.settings.badge.badgeSize}
                        />
                    ) : (
                        <i className={combineClassNames(
                            `${props.settings.badge.icon} text-3xl tall text-detail centered mr-3 flex`,
                            props.settings.badge.classes)}
                        />
                    )}
                </>
            )}

            <div className="row-based pr-4 tall justify-center overflow-hidden flex">
                <AgTechLink
                    content={props.header}
                    onClick={props.settings?.header?.onClick}
                    onHover={props.settings?.header?.onHover}
                    classes={combineClassNames('text-base font-semibold', props.settings?.header?.classes)}
                />
                {props.detail && (
                    <h1 className={combineClassNames('text-sm whitespace-pre text-detail font-normal text-wrap mt-[6px]', props.settings?.detail?.classes)}>
                        {props.detail}
                    </h1>
                )}
            </div>

            {contentFunc && (
                <div className={`ml-auto row-based tall flex ${props.settings?.content?.classes ?? ''}`}>
                    {contentFunc()}
                </div>
            )}
        </div>
    )
}

export default AgTechHeaderDetail;